var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-link-go-to",class:_vm.clazz,attrs:{"id":""}},[_c('span',{staticClass:"link-icon"},[_c('i',{class:_vm.icon,attrs:{"aria-hidden":"true"}})]),_c('span',{staticClass:"link-info"},[_c('label',[_vm._v(_vm._s(_vm.titleText))]),_c('p',[_vm._v(_vm._s(_vm.text))])]),_c('span',{staticClass:"link-go-to"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }